import * as React from 'react';

import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';
import BaseIcon from 'shared/newComponents/icons/BaseIcon';

const FileIcon: React.FC<CommonIconProps> = (props: CommonIconProps) => {
  return (
    <BaseIcon
      iconSize={IconSize.L}
      {...props}
      svgProps={{
        viewBox: '0 0 24 24'
      }}
    >
      <path
        d="M14.7 3H6.59999C6.1226 3 5.66476 3.18964 5.3272 3.52721C4.98963 3.86477 4.79999 4.32261 4.79999 4.8V19.2C4.79999 19.6774 4.98963 20.1352 5.3272 20.4728C5.66476 20.8104 6.1226 21 6.59999 21H17.4C17.8774 21 18.3352 20.8104 18.6728 20.4728C19.0103 20.1352 19.2 19.6774 19.2 19.2V7.5L14.7 3Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8 3V6.6C13.8 7.07739 13.9896 7.53523 14.3272 7.87279C14.6648 8.21036 15.1226 8.4 15.6 8.4H19.2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default React.memo(FileIcon);
